import { render } from "./AdicionarCentroCosto.vue?vue&type=template&id=1dd969f4"
import script from "./AdicionarCentroCosto.vue?vue&type=script&lang=js"
export * from "./AdicionarCentroCosto.vue?vue&type=script&lang=js"

import "./AdicionarCentroCosto.vue?vue&type=style&index=0&id=1dd969f4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__